import { languageKeyList, OptionsType } from "./CommonTypes";
import { fromEntries, nonNull } from "./react_utils";


export const srcEnding = '.minaro';

const validateSrc = (srcStr: string) => { 
  const src = srcStr.toLowerCase();
  if (src.startsWith('http://') || src.startsWith('https://')) { // allow non local sources only with special extension
    if(src.endsWith(srcEnding)) {
      return srcStr.slice(0, -srcEnding.length);
    }
    return null;
  }
  return srcStr;
};

const parseSingleOpt = (optString: string, validOptions: string[]): [string, string | number | boolean] | null => {
  const [opt, val] = [...optString.split('=', 2), 'true'].slice(0, 2);
  if (!validOptions.includes(opt)) {
    console.log(`Unknown Option is ignored: ${optString}`);
    return null;
  }

  switch (opt) {
    case 'width':
    case 'height':
    case 'pixel':
      const num = parseFloat(val);
      if (isNaN(num)) {
        console.log(`Invalid value for ${opt}: ${val}`);
        return null;
      }
      return [opt, val];
    case 'collapsed':
    case 'allowExternalSrc':
    case 'allowEdit':
      return [opt, val === 'true'];
    case 'lang':
      return languageKeyList.includes(val) ? [opt, val] : null;
    case 'src':
      const src = validateSrc(val);
      if (src !== null)
        return [opt, src];
      else return null;
    default:
      return [opt, val];
  }
};

export const parseOpts = (optStrings: string[], validOptions: string[]) => {
  const opts = optStrings.map(o => parseSingleOpt(o, validOptions)).filter(nonNull);
  return fromEntries(opts) as OptionsType;
};
